// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
ion-header.ion-no-border ion-toolbar {
  --border-width: 0;
  --border-color: transparent;
}

.addr-content {
  --padding-top: 0;
  --padding-bottom: 6px;
  --padding-start: 6px;
  --padding-end: 6px;
}

/* Search sits at the top of the content (on a plain background) and stays pinned while the
 * list scrolls — a single toolbar in the header avoids the stacked-toolbar seam. */
.addr-searchbar {
  position: sticky;
  top: 0;
  z-index: 5;
  padding: 8px 2px 4px;
  background: var(--ion-background-color, #ffffff);
}

ion-searchbar {
  --border-radius: 12px;
  --box-shadow: none;
  padding: 0;
}

.addr-list {
  background: transparent;
  padding: 0;
}

/* Selectable address row */
.addr-item {
  --background: var(--ion-item-background, #ffffff);
  --border-radius: 12px;
  --padding-start: 16px;
  --inner-padding-end: 12px;
  --min-height: 64px;
  margin: 6px 4px;
  border-radius: 12px;
  border: 1px solid rgba(var(--ion-color-primary-rgb), 0.1);
  transition: background 0.15s ease, border-color 0.15s ease;
}
.addr-item h2 {
  font-weight: 600;
  margin-bottom: 3px;
}

.addr-item--selected {
  --background: rgba(var(--ion-color-primary-rgb), 0.1);
  border-color: rgba(var(--ion-color-primary-rgb), 0.55);
}

.addr-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.82rem;
  color: var(--ion-color-medium, #7a7a7a);
}
.addr-meta__field {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
}
.addr-meta__field span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.addr-meta ion-icon {
  font-size: 14px;
  flex-shrink: 0;
}

/* Data-format pill (e.g. FLOAT / BOOL) */
.addr-format {
  flex-shrink: 0;
  padding: 1px 8px;
  border-radius: 999px;
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--ion-color-primary);
  background: rgba(var(--ion-color-primary-rgb), 0.12);
}

.addr-check {
  font-size: 24px;
  color: var(--ion-color-primary);
}

ion-footer.ion-no-border ion-toolbar {
  --border-width: 0;
  --border-color: transparent;
}

ion-footer ion-button[fill=solid] {
  --border-radius: 10px;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/components/general%20components/address-search/address-search.component.scss","webpack://./src/components/general components/address-search/address-search.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACE,iBAAA;EACA,2BAAA;ADEF;;ACCA;EACE,gBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;ADEF;;ACCA;mFAAA;AAEA;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,oBAAA;EACA,gDAAA;ADEF;;ACCA;EACE,qBAAA;EACA,kBAAA;EACA,UAAA;ADEF;;ACCA;EACE,uBAAA;EACA,UAAA;ADEF;;ACCA,2BAAA;AACA;EACE,iDAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,yDAAA;EACA,0DAAA;ADEF;ACAE;EACE,gBAAA;EACA,kBAAA;ADEJ;;ACEA;EACE,qDAAA;EACA,sDAAA;ADCF;;ACEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,uCAAA;ADCF;ACCE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;ADCJ;ACCI;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;ADCN;ACGE;EACE,eAAA;EACA,cAAA;ADDJ;;ACKA,yCAAA;AACA;EACE,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,+BAAA;EACA,oDAAA;ADFF;;ACKA;EACE,eAAA;EACA,+BAAA;ADFF;;ACKA;EACE,iBAAA;EACA,2BAAA;ADFF;;ACKA;EACE,qBAAA;EACA,gBAAA;ADFF","sourcesContent":["@charset \"UTF-8\";\nion-header.ion-no-border ion-toolbar {\n  --border-width: 0;\n  --border-color: transparent;\n}\n\n.addr-content {\n  --padding-top: 0;\n  --padding-bottom: 6px;\n  --padding-start: 6px;\n  --padding-end: 6px;\n}\n\n/* Search sits at the top of the content (on a plain background) and stays pinned while the\n * list scrolls — a single toolbar in the header avoids the stacked-toolbar seam. */\n.addr-searchbar {\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  padding: 8px 2px 4px;\n  background: var(--ion-background-color, #ffffff);\n}\n\nion-searchbar {\n  --border-radius: 12px;\n  --box-shadow: none;\n  padding: 0;\n}\n\n.addr-list {\n  background: transparent;\n  padding: 0;\n}\n\n/* Selectable address row */\n.addr-item {\n  --background: var(--ion-item-background, #ffffff);\n  --border-radius: 12px;\n  --padding-start: 16px;\n  --inner-padding-end: 12px;\n  --min-height: 64px;\n  margin: 6px 4px;\n  border-radius: 12px;\n  border: 1px solid rgba(var(--ion-color-primary-rgb), 0.1);\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n.addr-item h2 {\n  font-weight: 600;\n  margin-bottom: 3px;\n}\n\n.addr-item--selected {\n  --background: rgba(var(--ion-color-primary-rgb), 0.1);\n  border-color: rgba(var(--ion-color-primary-rgb), 0.55);\n}\n\n.addr-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.82rem;\n  color: var(--ion-color-medium, #7a7a7a);\n}\n.addr-meta__field {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  min-width: 0;\n}\n.addr-meta__field span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.addr-meta ion-icon {\n  font-size: 14px;\n  flex-shrink: 0;\n}\n\n/* Data-format pill (e.g. FLOAT / BOOL) */\n.addr-format {\n  flex-shrink: 0;\n  padding: 1px 8px;\n  border-radius: 999px;\n  font-size: 0.68rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: var(--ion-color-primary);\n  background: rgba(var(--ion-color-primary-rgb), 0.12);\n}\n\n.addr-check {\n  font-size: 24px;\n  color: var(--ion-color-primary);\n}\n\nion-footer.ion-no-border ion-toolbar {\n  --border-width: 0;\n  --border-color: transparent;\n}\n\nion-footer ion-button[fill=solid] {\n  --border-radius: 10px;\n  font-weight: 600;\n}","ion-header.ion-no-border ion-toolbar {\n  --border-width: 0;\n  --border-color: transparent;\n}\n\n.addr-content {\n  --padding-top: 0;\n  --padding-bottom: 6px;\n  --padding-start: 6px;\n  --padding-end: 6px;\n}\n\n/* Search sits at the top of the content (on a plain background) and stays pinned while the\n * list scrolls — a single toolbar in the header avoids the stacked-toolbar seam. */\n.addr-searchbar {\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  padding: 8px 2px 4px;\n  background: var(--ion-background-color, #ffffff);\n}\n\nion-searchbar {\n  --border-radius: 12px;\n  --box-shadow: none;\n  padding: 0;\n}\n\n.addr-list {\n  background: transparent;\n  padding: 0;\n}\n\n/* Selectable address row */\n.addr-item {\n  --background: var(--ion-item-background, #ffffff);\n  --border-radius: 12px;\n  --padding-start: 16px;\n  --inner-padding-end: 12px;\n  --min-height: 64px;\n  margin: 6px 4px;\n  border-radius: 12px;\n  border: 1px solid rgba(var(--ion-color-primary-rgb), 0.1);\n  transition: background 0.15s ease, border-color 0.15s ease;\n\n  h2 {\n    font-weight: 600;\n    margin-bottom: 3px;\n  }\n}\n\n.addr-item--selected {\n  --background: rgba(var(--ion-color-primary-rgb), 0.1);\n  border-color: rgba(var(--ion-color-primary-rgb), 0.55);\n}\n\n.addr-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.82rem;\n  color: var(--ion-color-medium, #7a7a7a);\n\n  &__field {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    min-width: 0;\n\n    span {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  }\n\n  ion-icon {\n    font-size: 14px;\n    flex-shrink: 0;\n  }\n}\n\n/* Data-format pill (e.g. FLOAT / BOOL) */\n.addr-format {\n  flex-shrink: 0;\n  padding: 1px 8px;\n  border-radius: 999px;\n  font-size: 0.68rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: var(--ion-color-primary);\n  background: rgba(var(--ion-color-primary-rgb), 0.12);\n}\n\n.addr-check {\n  font-size: 24px;\n  color: var(--ion-color-primary);\n}\n\nion-footer.ion-no-border ion-toolbar {\n  --border-width: 0;\n  --border-color: transparent;\n}\n\nion-footer ion-button[fill=\"solid\"] {\n  --border-radius: 10px;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
